import * as React from "react";
import { useHistory, useLocation } from "react-router";

import { DogResultsList } from "./results/DogResultsList";
import { DogAs400Form } from "./titles/DogAs400Form";
import { DogTitlesList } from "./titles/DogTitlesList";

export interface IDogCompetitionPageProps {
  dogId: number;
  editMode: boolean;
}

export const DogCompetitionPage: React.FunctionComponent<IDogCompetitionPageProps> = ({ dogId, editMode }) => {
  const history = useHistory();
  const { pathname } = useLocation();
  const changeEditMode = React.useCallback(
    (newEditMode: boolean) => {
      history.push(pathname.replace("view", "edit"));
    },
    [history, pathname]
  );
  return (
    <>
      <div style={{ marginBottom: "2rem" }}>
        {" "}
        <DogAs400Form dogId={dogId} editMode={editMode} />
      </div>

      <DogTitlesList dogId={dogId} editMode={editMode} />
      <DogResultsList dogId={dogId} editMode={editMode} />
    </>
  );
};
